export interface AppContext {
	NetworkSlug: string;
	FranchiseSlug: string;
	OperationId: number;
	CampaignId?: number;
	GoogleMapZoom?: string;
}

declare const Network: any;
declare const Franchise: any;
declare const Operation: any;
declare const Campaign: any;

export function parseAppContext(): AppContext {

	return {
		NetworkSlug: Network?.slug,
		FranchiseSlug: Franchise?.slug,
		OperationId: Operation?.id ?? null,
		CampaignId: Campaign?.id ?? null,
	};
}

export function initApp(appFn: (context: AppContext) => void) {
	appFn(parseAppContext());
}

